import { render } from "./Tem040.vue?vue&type=template&id=78b2ec33&scoped=true"
import script from "./Tem040.vue?vue&type=script&lang=js"
export * from "./Tem040.vue?vue&type=script&lang=js"

import "./Tem040.vue?vue&type=style&index=0&id=78b2ec33&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b2ec33"]])

export default __exports__